// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HmyQz","inner":"Footer_inner__3X3NT","nextIcon":"Footer_nextIcon__3joON","innerLeft":"Footer_innerLeft__2eesa"};